module.exports = __webpack_public_path__ + "static/media/guide-taste-4.9c77b84d.svg";